export default {
  LOAD_COMPETENCY_SURVEY_QUESTION_LIST_START: 'LoadCompetencySurveyQuestionListStart',
  LOAD_COMPETENCY_SURVEY_QUESTION_LIST_END: 'LoadCompetencySurveyQuestionListEnd',
  TOGGLE_COMPETENCY_SURVEY_QUESTION_LIST_CONFIRM_DIALOG: 'ToggleCompetencySurveyQuestionListConfirmDialog',
  CLEAR_COMPETENCY_SURVEY_QUESTION_LIST: 'ClearCompetencySurveyQuestionList'
};